module.exports = __webpack_public_path__ + "img/notification-panel.91094f51.svg";